export default '$$material';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/identifier.js
// module id = 109
// module chunks = 22